import { PagerSettings } from './PagerSettings';

/** A wrapper object that holds paged data information. */
export class PagedResult<T> {

	public pager: PagerSettings = new PagerSettings();
	public results: T[] = [];

	constructor(init?: Partial<PagedResult<T>>) {
		Object.assign(this, init);
	}

}
